// extracted by mini-css-extract-plugin
export default {"blurb":"FeatureWearable_blurb__hvBeX","blurbContainer":"FeatureWearable_blurbContainer__UqPna","imageList":"FeatureWearable_imageList__7Ll6O"};